var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,40.53c-4.119,0-7.47,3.351-7.47,7.47s3.351,7.471,7.47,7.471s7.471-3.352,7.471-7.471S52.119,40.53,48,40.53z  M48,51.471c-1.914,0-3.47-1.557-3.47-3.471c0-1.914,1.557-3.47,3.47-3.47c1.914,0,3.471,1.557,3.471,3.47 C51.471,49.914,49.914,51.471,48,51.471z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,23.5c-13.509,0-24.5,10.991-24.5,24.5c0,13.51,10.991,24.5,24.5,24.5c13.51,0,24.5-10.99,24.5-24.5 C72.5,34.491,61.51,23.5,48,23.5z M48,68.5c-11.304,0-20.5-9.196-20.5-20.5S36.696,27.5,48,27.5S68.5,36.696,68.5,48 S59.304,68.5,48,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,32.08c-8.778,0-15.92,7.142-15.92,15.92S39.222,63.92,48,63.92S63.92,56.778,63.92,48S56.778,32.08,48,32.08z  M48,59.92c-6.573,0-11.92-5.348-11.92-11.92c0-6.573,5.348-11.92,11.92-11.92c6.572,0,11.92,5.348,11.92,11.92 C59.92,54.572,54.572,59.92,48,59.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.f723735acdfac5b665febdcb28dccfee.svg";
export { ForwardRef as ReactComponent };